
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"65.295","height":"53.919"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"パス 217","d":"M43.643 42.458a12.074 12.074 0 01-1.179-2.848h-36.6a.366.366 0 01-.366-.366V5.868a.366.366 0 01.366-.366h52.779a.367.367 0 01.366.366v19.674a12.008 12.008 0 015.444 4.906c.023.039.036.081.058.121v-24.7A5.876 5.876 0 0058.643 0H5.869A5.876 5.876 0 000 5.869v33.38a5.875 5.875 0 005.869 5.868H45.75a11.889 11.889 0 01-2.107-2.659z","fill":"#12b6d4"}}),_c('path',{attrs:{"data-name":"パス 219","d":"M64.927 49.792l-3.74-6.478a9.9 9.9 0 10-7.118 3.044 9.788 9.788 0 002.353-.3l3.741 6.48a2.751 2.751 0 104.765-2.751zM50.239 38.656a4.4 4.4 0 116.013 1.612 4.411 4.411 0 01-6.013-1.612z","fill":"#12b6d4"}})])
          )
        }
      }
    